export default __webpack_public_path__ + "19d388224c38a869ad7893e7f0a6ec4f.svg";